import styled from 'styled-components';

export const SubmitWrapper = styled.div`
  padding-top: 15px;
`;
